import { useCookies } from 'react-cookie'
import { ROLES } from 'types/user'

export const useIsModerator = () => {
  const [{ tbR: roles = [] }] = useCookies(['tbR'])

  if (!Array.isArray(roles)) return false

  return roles.includes(ROLES.MOD)
}
